module.exports = __webpack_public_path__ + "static/media/island-tropical.9ec69eb9.svg";